import React, { useState } from "react";
import {
  Navbar,
  Typography,
  Button,
  IconButton,
  Card,
  Collapse,
  List,
  ListItem,
  ListItemPrefix,
  Menu,
  MenuHandler,
  MenuList,
  Avatar,
} from "@material-tailwind/react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
export function StickyNavbar({ pageType }) {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const isAuthPage = pageType === "login" || pageType === "register";
  const [openNav, setOpenNav] = React.useState(false);
  const [selectedLang, setSelectedLang] = useState("Canada");
  const changeLanguage = (country, lng) => {
    i18n.changeLanguage(lng);
    setSelectedLang(country);
  };
  const handleClose = () => {
    navigate("/");
  };
  React.useEffect(() => {
    window.addEventListener(
      "resize",
      () => window.innerWidth >= 960 && setOpenNav(false)
    );
  }, []);
  const navList = (
    <ul className="mt-4 mb-4 ml-4 flex flex-col gap-4 lg:mb-0 lg:mt-0 lg:flex-row lg:items-center lg:gap-6">
      <Typography
        as="li"
        variant="small"
        color="blue-gray"
        className="p-1 font-normal"
      >
        <a href="#how-it-works" className="flex items-center" onClick={() => setOpenNav(false)}>
          How it works
        </a>
      </Typography>
      <hr></hr>
      <Typography
        as="li"
        variant="small"
        color="blue-gray"
        className="p-1 font-normal"
      >
        <a href="#why-adulis" className="flex items-center" onClick={() => setOpenNav(false)}>
          Why Adulis
        </a>
      </Typography>
      <hr></hr>
      <Typography
        as="li"
        variant="small"
        color="blue-gray"
        className="p-1 font-normal"
      >
        <a href="#faqs" className="flex items-center" onClick={() => setOpenNav(false)}>
          FAQs
        </a>
      </Typography>
      <hr></hr>
      <Typography
        as="li"
        variant="small"
        color="blue-gray"
        className="p-1 font-normal"
      >
        <a href="#contact" className="flex items-center" onClick={() => setOpenNav(false)}>
          Contact
        </a>
      </Typography>
      <hr></hr>
    </ul>
  );
  return (
    <div className="mx-auto w-full max-w-[960px] px-3 pt-2 sm:px-6 md:pt-3">
      <Navbar className="relative m-auto h-max max-w-full rounded-2xl border border-[#e6ddd2] bg-[#fffdf9] px-3 py-1 font-sora shadow-[0_8px_28px_rgba(66,48,34,0.12)] sm:px-4 lg:px-5">
        <div className="relative flex items-center justify-between text-[#302521]">
          <Typography
            as="a"
            href="/"
            className=" cursor-pointer py-1.5 font-semibold flex items-center gap-2"
          >
            {/* <img
              src="/logo_ams.svg"
              alt="logo"
              className="hidden md:block w-14 h-14 fill-purple-500"
            /> */}
            <div className="ml-1 rounded-lg bg-[#882699] px-2 py-1.5 text-[11px] font-extrabold text-white sm:text-[13px]">
              AMS
            </div>
            <div className="flex flex-col text-[#302521]">
              <div className="text-[11px] sm:text-[12px]">
                Adulis Money Services
              </div>
            </div>
          </Typography>
          {(!pageType || isAuthPage) && (
            <nav className="hidden items-center gap-4 text-[11px] text-[#766b64] lg:flex xl:gap-5" aria-label="Main navigation">
              <a className="transition hover:text-[#882699]" href={isAuthPage ? "/#how-it-works" : "#how-it-works"}>How it works</a>
              <a className="transition hover:text-[#882699]" href={isAuthPage ? "/#why-adulis" : "#why-adulis"}>Why Adulis</a>
              <a className="transition hover:text-[#882699]" href={isAuthPage ? "/#faqs" : "#faqs"}>FAQs</a>
              <a className="transition hover:text-[#882699]" href={isAuthPage ? "/#contact" : "#contact"}>Contact</a>
            </nav>
          )}
          {pageType != "mobileView" && (
            <div className="flex items-center gap-4">
              <div className="flex items-center md:gap-x-3 gap-x-1">
                <div className="md:mr-6 mr-2  max-w-24 ">
                  <Menu>
                    {/* <MenuHandler>
                      <div className="flex gap-1 justify-center items-center">
                        <img
                          src={`/${selectedLang}.png`}
                          className="md:w-8 md:h-8 w-5 h-5"
                          alt="Eritrea"
                        />
                        <span className="text-[13px] text-black font-extrabold">
                          {selectedLang == "Canada"
                            ? "ENG"
                            : selectedLang == "Eritrea"
                            ? "TIG"
                            : "AMH"}
                        </span>
                      </div>
                    </MenuHandler> */}
                    <MenuList>
                      <List className="p-1 max-w-[100px] min-w-[140px]">
                        <ListItem
                          onClick={() => changeLanguage("Eritrea", "tig")}
                          className="p-1"
                        >
                          <ListItemPrefix>
                            <img
                              src="/Eritrea.png"
                              className="md:w-8 md:h-8 w-5 h-5"
                              alt="Eritrea"
                            />
                          </ListItemPrefix>
                          <div>
                            <Typography variant="h6" color="blue-gray">
                              Tigrinya
                            </Typography>
                          </div>
                        </ListItem>
                        <ListItem
                          onClick={() => changeLanguage("Ethiopia", "amh")}
                          className="p-1"
                        >
                          <ListItemPrefix>
                            <img
                              src="/Ethiopia.png"
                              className="md:w-8 md:h-8 w-5 h-5"
                              alt="Ethiopia"
                            />
                          </ListItemPrefix>
                          <div>
                            <Typography variant="h6" color="blue-gray">
                              Amharic
                            </Typography>
                          </div>
                        </ListItem>
                        <ListItem
                          onClick={() => changeLanguage("Canada", "eng")}
                          className="p-1"
                        >
                          <ListItemPrefix>
                            <img
                              src="/Canada.png"
                              className="md:w-8 md:h-8 w-5 h-5"
                              alt="Canada"
                            />
                          </ListItemPrefix>
                          <div>
                            <Typography variant="h6" color="blue-gray">
                              English
                            </Typography>
                          </div>
                        </ListItem>
                      </List>
                    </MenuList>
                  </Menu>
                </div>
                {!pageType && (
                  <>
                    <Link to={"/login"}>
                      <Button
                        variant="outlined"
                        size="sm"
                        color="purple"
                        className="hidden rounded-full border-[#882699]/40 text-[#882699] lg:inline-block"
                      >
                        <span>{i18n.t("logIn")}</span>
                      </Button>
                    </Link>
                    <Link to={"/register"}>
                      <Button
                        variant="button"
                        size="sm"
                        className="hidden rounded-full bg-[#882699] text-white hover:bg-[#9e32b4] lg:inline-block"
                      >
                        <span>{i18n.t("register")}</span>
                      </Button>
                    </Link>
                  </>
                )}
                {isAuthPage && (
                  <>
                    {pageType === "login" ? (
                      <Link to="/register">
                        <Button
                          variant="button"
                          size="sm"
                          className="rounded-full bg-[#882699] text-white hover:bg-[#9e32b4]"
                        >
                          <span>{i18n.t("register")}</span>
                        </Button>
                      </Link>
                    ) : (
                      <Link to="/login">
                        <Button
                          variant="outlined"
                          size="sm"
                          color="purple"
                          className="rounded-full border-[#882699]/40 text-[#882699]"
                        >
                          <span>{i18n.t("logIn")}</span>
                        </Button>
                      </Link>
                    )}
                    <button
                      type="button"
                      onClick={handleClose}
                      aria-label="Return to home"
                      className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-[#e6ddd2] text-[#766b64] transition hover:bg-[#f3eee7] hover:text-[#882699]"
                    >
                      <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 6l12 12M18 6 6 18" />
                      </svg>
                    </button>
                  </>
                )}
                {!!pageType && pageType != "static" && !isAuthPage && (
                  <button
                    type="button"
                    onClick={() => handleClose()}
                    class="bg-white rounded-md p-2 inline-flex items-center justify-center text-purple-600 hover:text-purple-300 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
                  >
                    <span class="sr-only">Close menu</span>
                    <svg
                      class="h-6 w-6"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                )}
              </div>
              <IconButton
                variant="text"
                className="ml-auto h-6 w-6 text-[#302521] hover:bg-transparent focus:bg-transparent active:bg-transparent lg:hidden"
                ripple={false}
                onClick={() => setOpenNav(!openNav)}
              >
                {openNav ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    className="h-6 w-6"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  </svg>
                )}
              </IconButton>
            </div>
          )}
        </div>
        <Collapse
          open={openNav}
          className={`absolute left-0 right-0 top-full z-50 rounded-2xl lg:hidden ${
            openNav
              ? "mt-2 max-h-[calc(100dvh-90px)] overflow-y-auto border border-[#e6ddd2] bg-[#fffdf9] px-3 py-2 shadow-[0_16px_40px_rgba(66,48,34,0.18)]"
              : "invisible pointer-events-none overflow-hidden border-0 p-0 shadow-none"
          }`}
        >
          <hr></hr>
          {navList}
          <div className="mt-10 ml-4 flex flex-col gap-5">
            {isAuthPage ? (
              pageType === "login" ? (
                <Link to="/register">
                  <Button fullWidth variant="button" className="bg-[#882699] hover:bg-[#9e32b4]" size="lg">
                    <span>{i18n.t("register")}</span>
                  </Button>
                </Link>
              ) : (
                <Link to="/login">
                  <Button fullWidth variant="outlined" color="purple" size="lg" className="border-[#882699]/40 text-[#882699]">
                    <span>{i18n.t("logIn")}</span>
                  </Button>
                </Link>
              )
            ) : (
              <>
                <Link to="/login">
                  <Button fullWidth variant="outlined" size="lg">
                    <span>{i18n.t("logIn")}</span>
                  </Button>
                </Link>
                <Link to="/register">
                  <Button fullWidth variant="button" className="bg-[#882699] hover:bg-[#9e32b4]" size="lg">
                    <span>{i18n.t("register")}</span>
                  </Button>
                </Link>
              </>
            )}
          </div>
        </Collapse>
      </Navbar>
    </div>
  );
}
